import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["value"];

  connect() {
    let selectedValue;
    let checkedItem;

    this.valueTargets.forEach((el) => {
      if (el.checked) {
        checkedItem = el;
      }
    });

    if (this.valueTargets.length === 1) {
      selectedValue = this.valueTarget.value;
      this.valueTarget.checked = true;
    } else if (checkedItem) {
      selectedValue = checkedItem.value;
    } else if (this.hasValueTarget) {
      selectedValue = this.valueTargets[0].value;
      this.valueTargets[0].checked = true;
    }

    this.changeTo(selectedValue);
  }

  change(event) {
    const newValue = event.currentTarget.value;
    this.changeTo(newValue);
  }

  changeTo(value) {
    this.element.querySelectorAll(`[data-toggle]`).forEach((el) => {
      const list = el.dataset.toggle.split(",");
      const inputs = el.querySelectorAll("input");

      if (list.includes(value)) {
        el.classList.remove("hidden");
        inputs.forEach((el) => el.removeAttribute("disabled"));
      } else {
        el.classList.add("hidden");
        inputs.forEach((el) => el.setAttribute("disabled", ""));
      }
    });
  }
}
